import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material';

export const Box = MuiBox;
export type BoxProps = MuiBoxProps;
